import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'

// import ArgosIcon from '../Icons/Argos'
import { Avatar } from '../../Common'

const cn = bem({ prefix: 'lc-', block: 'spinner' })

const Spinner = ({ className, size, strokeWidth }) => {
  const avatarSize = Math.ceil(size / 3)

  return (
    <div aria-busy='true' className={`${cn()} ${className}`} style={{ width: size, height: size / 2 }}>
      <svg className={cn('svg')} viewBox='0 0 100 100' style={{ width: size, height: size }}>
        <circle
          className={cn('path')}
          cx={50}
          cy={50}
          r={20}
          fill='none'
          stroke='#DA322A'
          strokeWidth={strokeWidth}
          strokeMiterlimit={10}
        />
      </svg>

      <Avatar
        height={avatarSize}
        width={avatarSize}
        style={{ marginTop: `-${avatarSize / 2}px`, marginLeft: `-${avatarSize / 2}px` }}
        type='system'
        className={cn('argos-logo')}
      />
    </div>
  )
}

Spinner.defaultProps = {
  size: 130,
  strokeWidth: 3,
}

Spinner.propTypes = {
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
}

export default Spinner
